import { PropertyTypes } from './property-types'
import { Areas } from './states-areas'
import { Scopes } from './forms/types'


const options = [
  {
    name: 'fullColorForSaleSign',
    scope: Scopes.ByPropertyType,
    types: [PropertyTypes.HomeSale, PropertyTypes.LandSale],
    title: 'Full Color For Sale Sign',
    description: `
      Make your property stand out with a professional, full-color 18" × 24" For Sale sign. The durable, double-sided design includes space for your phone number, so interested buyers contact you directly. An H-stake is included for quick installation with no additional hardware required—and the sign is yours to keep.
    `,
    help: `Delivered by FedEx or USPS usuallywithin 1-3 business days. Small shipping cost applies.`,
    img: 'full-color-for-sale.jpg',
    label: ' To Order a Full Color For Sale Sign',
    price: 30,
    delivery: 13.85,
  },
  {
    name: 'blueAndWhiteForSaleSign',
    scope: Scopes.ByPropertyType,
    types: [PropertyTypes.HomeSale, PropertyTypes.LandSale],
    title: 'Blue and White For Sale Sign',
    description: `
      Give your property a polished, professional look with this attractive blue-and-white 18" × 24" For Sale sign. It is printed on both sides and includes space for your phone number, allowing interested buyers to contact you directly. An H-stake is included for easy installation with no additional hardware required—and the sign is yours to keep.
    `,
    help: `Delivered by FedEx or USPS usually within 1-3 business days. Small shipping cost applies.`,
    img: 'blue-and-white-for-sale.jpg',
    label: 'Check This Box To Order a Blue and White For Sale Sign',
    price: 20,
    delivery: 13.85,
  },
  {
    name: 'woodenSignPost',
    scope: Scopes.IndividualMapping,
    mapping: {
      [Areas.Bright]: [PropertyTypes.HomeSale, PropertyTypes.LandSale],
    },
    title: 'Wooden Sign Post',
    description: `
      Nothing says "Buy Me" more than a professional wooden sign post. Installed with a wooden post, metal panel, and 
      brochure box - this prestigious wooden sign post offers maximum high visibility and a quality presentation. Price 
      includes professional installation and removal after the listing is over. Sign posts are usually installed within 
      1-3 business days.
    `,
    img: 'wooden-sign-post.jpg',
    label: 'Check This Box To Order a Wooden Sign Post',
    price: 99,
  },
    {
    name: 'forRentSign',
    scope: Scopes.ByPropertyType,
    types: [PropertyTypes.HomeRent],
    title: 'For Rent Sign',
    description: `
      This Professional Looking, 18 x 24, For Rent sign is Double Sided with a Blank Call Space for Your Phone Number 
      (so you will get all of the calls). An H Stand is included for easy installation. No hardware is required. This 
      sign is yours to keep and does not need to be returned to us.
    `,
    help: `Delivered by FedEx or USPS usually within 1-3 business days. Small shipping cost applies.`,
    img: 'for-rent-sign.jpg',
    label: 'Check This Box to Order a Blue and White For Rent Sign',
    price: 20,
    delivery: 13.85,
  },
   {
    name: 'lockbox',
    scope: Scopes.IndividualMapping,
    mapping: {
      [Areas.Charlotte]: [PropertyTypes.HomeSale, PropertyTypes.HomeRent],      
      [Areas.Triangle]: [PropertyTypes.HomeSale, PropertyTypes.HomeRent],
      [Areas.Coastal]: [PropertyTypes.HomeSale, PropertyTypes.HomeRent],
      [Areas.Georgia]: [PropertyTypes.HomeSale, PropertyTypes.HomeRent],
      [Areas.Charleston]: [PropertyTypes.HomeSale, PropertyTypes.HomeRent],
    },
    title: 'MLS Lockbox',
    description: {
      default: `
        A lockbox is a universal metal container for your house key that is hung on the front door and can only be 
        opened by a special key carried by licensed real estate agents. It provides access when you are unable to show 
        the home, thus assuring full exposure to prospective buyers. Real Estate Agents are on a fast track and depend 
        heavily on lockboxes for quick access to homes. They are completely removable and controllable by you and fit 
        conveniently over the door frame, not the handle, so you may simply slip it off the frame and bring it inside 
        whenever wish.
      `,
      scope: Scopes.ByPropertyType,
      types: {
        [PropertyTypes.HomeRent]: `
          An MLS lockbox securely holds a key to your property and can be opened only by authorized real estate agents. It allows agents to show your home when you are unavailable, making it easier to accommodate prospective buyers and avoid missed showing opportunities. The lockbox fits over the top of the door—not on the handle—and can be easily removed and brought inside whenever you choose.
        `
      },
    },
    help: `
      Lockbox is leased and remains the property of Select Premium Properties. Lockbox is delivered by FedEx or USPS and 
      usually arrives within 1-3 business days. Small shipping cost applies.
    `,
    img: {
      default: 'lockbox.jpg',
      scope: Scopes.ByMLSArea,
      areas: {
        [Areas.Charlotte]: 'lockbox-supra.jpg',      
        [Areas.Coastal]: 'lockbox-supra.jpg',
        [Areas.Triangle]: 'lockbox-white.jpg',
        [Areas.Charleston]: 'lockbox-white.jpg',
        [Areas.Georgia]: 'lockbox-supra-ibox.jpg',
      },
    },
    label: 'Check This Box To Order an MLS Lockbox',
    price: 75,
    delivery: 14.85,
  },
  {
    name: 'openHouseAnnouncement',
    scope: Scopes.ByPropertyType,
    types: [PropertyTypes.HomeSale, PropertyTypes.HomeRent],
    title: 'Open House Announcement',
    description: {
      default: `
        Promote your next Open House with an announcement in the MLS, on Realtor.com and other MLS associated websites. 
        Let agents and buyers know when you are holding an open house. Save time and get more showings!
      `,
      scope: Scopes.ByPropertyType,
      types: {
        [PropertyTypes.HomeRent]: `
          Promote your next Open House with an announcement in the MLS, on Realtor.com and other MLS associated websites. 
          Let agents and renters know when you are holding an open house. Save time and get more showings!
        `,
      }
    },
    img: 'open-house-announcement.svg',
    label: 'Check This Box To Order the Open House Announcement',
    price: 20,
  },  
   {
    name: 'homeWarrantyCoverage',
    scope: Scopes.ByPropertyType,
    types: [PropertyTypes.HomeSale],
    title: 'Home Warranty Coverage',
    description: {
      default: `
        <p>Help protect against unexpected covered repairs to home systems and appliances while your property is listed. At closing, the warranty transfers to the buyer for one full year—adding value to your listing, giving buyers greater confidence and helping your property stand out. <a href="https://www.expressmlslistings.com/HomeWarrantyInfo.html" class="link" target="_blank">Click Here<a> for more coverage information.</p>
        <p class="mt-1">$488 - Order Now for Coverage. No Payment Due Until Closing.</p>
      `,
      scope: Scopes.ByMLSArea,
      areas: {
        [Areas.Bright]: `
          <p>Help protect against unexpected covered repairs to home systems and appliances while your property is listed. At closing, the warranty transfers to the buyer for one full year—adding value to your listing, giving buyers greater confidence and helping your property stand out. <a href="https://www.expressmlslistings.com/HomeWarrantyInfo.html" class="link" target="_blank">Click Here</a> for more coverage information.</p>
          <p class="mt-1">$569 - Order Now for Coverage. No Payment Due Until Closing.</p>
        `,
        [Areas.Georgia]: `
          <p>Help protect against unexpected covered repairs to home systems and appliances while your property is listed. At closing, the warranty transfers to the buyer for one full year—adding value to your listing, giving buyers greater confidence and helping your property stand out. <a href="https://www.expressmlslistings.com/HomeWarrantyInfo.html" class="link" target="_blank">Click Here</a> for more coverage information.</p>
          <p class="mt-1">$488 - Order Now for Coverage. No Payment Due Until Closing.</p>
        `,
      }
    },
    help: `Sales tax may apply depending on your local jurisdiction.`,
    img: 'one-year-warranty.svg',
    label: 'Check This Box To Order the 1 Year Home Warranty',
    price: null,
    replacePriceOnCheckoutWith: 'Paid at closing',
  },
  {
    name: 'contractReview',
    scope: Scopes.ByPropertyType,
    types: [PropertyTypes.HomeSale, PropertyTypes.LandSale],
    title: 'Contract Review with Broker',
    description: `
      Review purchase offers with an experienced broker before you respond. The broker will walk you through important terms, contingencies, deadlines and the contract process; answer non-legal questions; and discuss points you may want to consider during negotiations. You remain in control while receiving experienced guidance to help you evaluate each offer with greater clarity and confidence. Price 
      includes unlimited purchase contract reviews.
    `,
    img: 'contract-review.svg',
    label: 'Check This Box To Order the Contract Review with Broker',
    price: 299,
  },
]


export {
  options,
}